//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import {HeadBar, CellRow, PhoneCode, Card, BccPasswordDialog, Coupon} from '@/components';
  import CustomerNameInput from './components/CustomerNameInput';
  import OperationBtn from './components/OperationBtn';
  import RoomsSelector from './components/RoomsSelector';
  import SettlementTips from './components/SettlementTips';
  import TimePopup from './components/TimePopup';
  import BookingDetail from './components/BookingDetail';
  import PlacingTypeRadios from './components/PlacingTypeRadios';
  import HotelBaseInfo from './components/HotelBaseInfo';
  // import BccPasswordDialog from './components/BccPasswordDialog';
  import BccRechargeModal from './components/BccRechargeModal';
  import {OrderProxy} from '@/http/RequestProxy.class';

  const orderProxy = new OrderProxy();
  const EMAIL_REG = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;

  export default {
    name: 'book-hotel',
    components: {
      Coupon,
      BookingDetail,
      TimePopup,
      SettlementTips,
      RoomsSelector,
      OperationBtn,
      Card,
      PhoneCode,
      CustomerNameInput,
      CellRow,
      HeadBar,
      HotelBaseInfo,
      PlacingTypeRadios,
      BccPasswordDialog,
      BccRechargeModal,
    },
    data(){
      return {
        isShowAmount: false,
        isShowSettlementTips: false,
        isShowTimePopup: false,
        isShowBookDetail: false,
        isShowPwdDialog: false,       // 显示bcc密码输入弹窗
        isShowRechargeModal: false,   // bcc充值提示弹窗
        bccPasswordError: false,      // bcc支付密码是否错误
        isShowCouponList: false,      // 显示优惠券列表
        isEmpty: {
          contactName: false,
          email: false,
          areaCode: false,
          phone: false,
        },

        placingType: 0,   // 下单类型1为bcc下单, 0为普通下单

        // 必填项输入框是否获得焦点标识
        contactNameHover: false,
        emailHover: false,
        areaCodeHover: false,
        phoneHover: false,

        // 路由携带过来的参数
        routerParams: '',
        // 酒店数据
        hotelData: '',
        // 入住方案数据
        planData: '',
        // 价格数据
        priceList: [],
        supplierData: {
          is_able_to_change_room: false,
        },
        currencyCode: 'CNY',

        userWallet: {           // 用户的钱包数据
          bcc: {},
        },
        bccDiscountAmount: 0,   // bcc优惠金额

        // 下单时提交的字段
        query: {
          bcc_pwd: '',
          coupon_sn: '',
          person_list: [],
          contact_name: '',
          phone_area_code: '',
          phone: '',
          email: '',
          estimated_checkin_time: '',
          total_price: 0,
          room_count: this.$store.getters.getRooms,
          filter: {
            room_count: this.$store.getters.getRooms,
            adults: this.$store.getters.getAdults,
            children: this.$store.getters.getAges,
          },
        },
        tempNameArr: [],
        couponData: {},     // 使用的优惠券
        couponCount: 0,     // 可用优惠券数量
        couponDiscount: 0,  // 优惠券抵扣金额
      };
    },
    watch: {
      // 下单方式更改时重新计算价格
      placingType(newType){
        this.calcPrice();
      },
    },
    computed: {
      // 语言类型
      lanType(){
        return +window.localStorage.getItem('lan_type');
      },
    },
    mounted(){
      this.routerParams = Object.assign({}, this.$route.query, {order_type: 1});
      this.query = Object.assign({}, this.query, this.routerParams);

      this.getHotelInfo();
      this.getUserWallet();
      this.readUserInfoFromLocal();
      this.timeoutTips();

      this.$nextTick(() => {
        document.documentElement.scrollTop = 0;
      });
    },
    methods: {
      /** 获取酒店详情数据 */
      getHotelInfo(){
        this.$vux.loading.show({text: this.$i18n.t('hotel.LOADING')});

        orderProxy.prepareHotelOrder(this.routerParams)
          .then(resp => {
            if(resp){
              const data = resp.data;
              const dateHash = {
                start_date: this.routerParams.start_date,
                end_date: this.routerParams.end_date,
              };

              this.hotelData = Object.assign({}, data, dateHash);
              this.planData = data.plan_info;
              this.priceList = data.price_list;
              this.supplierData = data.supplier_info;
              this.currencyCode = data.price_list[0].currency_code;

              this.query.filter.adults = data.room_type_info.maximum_capacity;
              this.query.total_price = data.plan_info.package_total_price;
              this.calcPrice(); // 初始化时计算总价
            }
            this.$vux.loading.hide();
          });
      },

      /** 获取用户的钱包数据 */
      getUserWallet(){
        orderProxy.getUserWallet()
          .then(resp => {
            if(resp){
              this.userWallet = resp.data;
            }
          });
      },

      /** 选择房间数量 */
      onGetRooms(num){
        this.query.room_count = num;
        this.calcPrice();
      },

      /** 改变手机地区号 */
      onChangeCode(code){
        this.query.phone_area_code = code;
      },

      /** 选择到店时间 */
      onGetTime(time){
        this.query.estimated_checkin_time = time;
      },

      /** 获取可用优惠券数量 */
      onGetCouponCount(count){
        this.couponCount = count;
      },

      /** 获取优惠券数据 */
      onGetSelectCoupon(couponData){
        this.couponData = couponData;
        this.query.coupon_sn = couponData.serial_num;
        this.calcPrice();
      },

      /** 表单获得焦点 */
      onFocus(iptType){
        switch (iptType){
          case 'contactName':
            this.contactNameHover = true;
            break;
          case 'email':
            this.emailHover = true;
            break;
          case 'phone':
            this.phoneHover = true;
            break;
          default: break;
        }
      },

      /** 表单失去焦点 */
      onBlur(iptType){
        switch (iptType){
          case 'contactName':
            this.contactNameHover = false;
            break;
          case 'email':
            this.emailHover = false;
            break;
          case 'phone':
            this.phoneHover = false;
            break;
          default: break;
        }
      },

      /** 计算总金额 */
      calcPrice(){
        const total = Number(this.query.room_count) * Number(this.planData.package_total_price);

        this.query.total_price = total;

        // bcc优惠
        if(+this.placingType === 1){
          this.bccDiscountAmount = Number(this.query.room_count) * this.planData.bcc_discount_price_per_room;
        }else{
          this.bccDiscountAmount = 0;
        }

        // 优惠券优惠
        if(+this.couponData.status_type === 3){
          if(+this.couponData.type === 1){
            this.couponDiscount = +this.couponData.amount;
          }else{
            const maxDiscount = +this.couponData.max_deduction_amount;
            const discountPerson = +this.couponData.precent_amount;
            const discountAmount = Math.floor(this.query.total_price * (discountPerson / 100));

            this.couponDiscount = maxDiscount > discountAmount ? discountAmount : maxDiscount;
          }
        }else{
          this.couponDiscount = 0;
        }
      },

      /** 查看费用明细 */
      onViewFeeDetail(){
        this.isShowBookDetail = !this.isShowBookDetail;
      },

      /** 入住人姓名数据处理 */
      dealWithCustomerName(){
        let custom = this.$refs['customerName'];
        let personFlag = {};

        this.query.person_list = [];
        for(let count = 0; count < (this.query.room_count * this.query.filter.adults); count++){
          let hash = custom[count].getCustomData();

          if(hash){
            this.query.person_list.push(hash);
            personFlag[hash['room_id']] = true;
          }
        }

        // 校验入住人姓名拼音输入
        for(let i = 1; i <= this.query.room_count; i++){
          let key = String(i);

          if(!personFlag[key]){
            // 请填写完整入住人信息
            this.toast(this.$i18n.t('hotel.Guest_name_must_be_provided'));
            return false;
          }
        }

        return true;
      },

      /** 必填字段校验 */
      paramsValidate(){
        let query = this.query;

        if(!query.phone){
          // 请输入手机号
          this.toast(this.$i18n.t('hotel.Please_fill_in_your_contact_number'));
          this.isEmpty.phone = true;
          return false;
        }else if(!query.email || !EMAIL_REG.test(query.email)){
	        // 请输入正确的邮箱地址
          this.toast(this.$i18n.t('hotel.Emial_address'));
          this.isEmpty.email = true;
          return false;
        }else if(!query.contact_name){
          // 请输入联系人姓名
          this.toast(this.$i18n.t('hotel.TRAVEL_PHONE_NUMBER'));
          this.isEmpty.contactName = true;
          return false;
        }else if(!query.phone_area_code){
          // 请选择国家地区号
          this.toast(this.$i18n.t('hotel.PLEASE_SELECT_AREA_CODE'));
          this.isEmpty.areaCode = true;
          return false;
        }else if(!query.estimated_checkin_time){
          // 请输选择预计到店时间
          this.toast(this.$i18n.t('hotel.Select_estimated_time_of_arrival'));
          return false;
        }

        return true;
      },

      toast(tips){
        this.$vux.toast.show({
          text: tips,
        });
      },

      /** 重置入住成人数 */
      resetAdults(){
        const rooms = this.query.room_count;
        const adults = this.query.adults;
        const maxAdults = rooms * 10;

        if(adults > maxAdults){
          this.query.adults = maxAdults;
        }
      },

      /** 提交订单 */
      onSetOrder(){
        if(this.dealWithCustomerName() && this.paramsValidate()){
          if(+this.placingType === 1 && !this.query.bcc_pwd){
            // 未设置bcc支付密码
            if(!this.userWallet.bcc.is_set_pwd){
              this.$vux.confirm.show({
                content: '您还没有设置bcc支付密码！',
                confirmText: '前往设置',
                cancelText: '取消',
                onConfirm(){
                  window.location.href = `${this.$store.state.WAP_HOST}pay_pwd.php?redirect_url=${encodeURIComponent(window.location.href)}`;
                }
              });
              return false;
            }

            // 用户bcc余额不足，引导用户去充值
            if(this.query.total_price - this.bccDiscountAmount > this.userWallet.bcc.balance){
              this.isShowRechargeModal = true;
              return false;
            }

            this.isShowPwdDialog = true;  // 显示密码输入弹窗
            return false;
          }

          this.resetAdults();

          if(+this.placingType === 1){
            this.placingWithBCC();    // BCC下单
          }else{
            this.popularPlacing();    // 普通方式下单
          }
        }
      },

      /** bcc会员下单 */
      placingWithBCC(){
        this.$vux.loading.show();
        orderProxy.placingHotelOrderWithBCC(this.query)
          .then(resp => {
            if(resp) {
              if (+resp.code === 30902) { // 支付密码错误
                this.bccPasswordError = true;
                this.$vux.toast.show({text: resp.msg});
              } else {
                this.$router.push({name: 'payment-success', params: {order_id: resp.data.payment_info.order_id}});
              }
              this.$vux.loading.hide();
            }
          });
      },

      /** 普通方式下单 */
      popularPlacing(){
        this.$vux.loading.show();
        orderProxy.placingHotelOrder(this.query)
          .then(resp => {
            if(resp){
              window.location.href = `${window.location.origin}/m/hotel/payment?order_id=${resp.data.order_id}`;
              this.saveUserToLocal();
            }else{
              this.router2FailedPage();
            }
            this.$vux.loading.hide();
          });
      },

      /** 前往bcc余额充值 */
      onRechargeBcc(rechargeBcc){
        this.isShowRechargeModal = false;
        if(+rechargeBcc === 1){
          window.location.href = `${this.$store.state.WAP_HOST}bcc.php?act=card_select`;
        }else{
          this.placingType = 0;
          this.popularPlacing();
        }
      },

      /** 路由到下单失败页面 */
      router2FailedPage(){
        const param = {
          hotel_id: this.query.hotel_id,
          start_date: this.query.start_date,
          end_date: this.query.end_date,
        };

        this.$router.push({name: 'booking-fail', query: param});
      },

      /** 保存用户信息到本地 */
      saveUserToLocal(){
        const {person_list, phone_area_code, phone, email, contact_name} = this.query;
        let defaultHash = window.localStorage.getItem('booking_info');

        if(defaultHash){
          defaultHash = JSON.parse(defaultHash);
        }else{
          defaultHash = {};
        }

        const tempHash = {};

        if(person_list.length > 0){
          tempHash['person_list'] = person_list;
        }

        if(phone_area_code){
          tempHash['phone_area_code'] = phone_area_code;
        }

        if(phone){
          tempHash['phone'] = phone;
        }

        if(email && EMAIL_REG.test(email)){
          tempHash['email'] = email;
        }

        if(contact_name){
          tempHash['contact_name'] = contact_name;
        }

        const result = Object.assign({}, defaultHash, tempHash);

        window.localStorage.setItem('booking_info', JSON.stringify(result));
      },

      /** 从本地存储读取数据 */
      readUserInfoFromLocal(){
        let data = window.localStorage.getItem('booking_info');

        if(data){
          data = JSON.parse(data);

          this.tempNameArr = data.person_list || [],
          this.query.phone_area_code = data.phone_area_code || '';
          this.query.phone = data.phone || '';
          this.query.email = data.email || '';
          this.query.contact_name = data.contact_name || '';
        }
      },

      /** 返回上一页 */
      onBack(){
        this.saveUserToLocal();
        this.$router.back();
      },

      /** 停留30分钟后不提交订单超时提示 */
      timeoutTips(){
        setTimeout(() => {
          this.$vux.alert.show({
            content: this.$i18n.t('hotel.BOOK_TIMEOUT_TIPS'),
            onHide: () => {
              this.onBack();
            },
          });
        }, 1800000);
      },
    },
  };



// WEBPACK FOOTER //
// ./src/views/hotel-booking/hotel-booking.vue